module.exports = __webpack_public_path__ + "img/16m007-07.1c9130b6.jpg";